<template>
  <footer class="main-footer">
    <div class="row">

      <div class="col-12 d-flex justify-content-center">
        <img
          src="@/assets/images/logo-white.svg"
          :alt="'Logotipo ' + $store.state.websiteName"
          :title="$store.state.websiteName"
          class="mb-5"
        />
      </div>

      <div class="col-12 my-5 d-flex flex-column align-items-center justify-content-center">
        <p>Conheça mais sobre a Grupo Boticário:</p>

        <ul>
          <li> <a href="https://www.linkedin.com/company/grupo-boticario/?originalSubdomain=br" target="_blank"> <img src="@/assets/images/linkedin.svg" aria-label="Linkedin" /> </a> </li>
          <li> <a href="https://www.instagram.com/grupoboticario/" target="_blank"> <img src="@/assets/images/instagram.svg" aria-label="instagram" /> </a> </li>
          <li> <a href="https://www.facebook.com/grupoboticario/?locale=pt_BR" target="_blank"> <img src="@/assets/images/facebook.svg" aria-label="facebook" /> </a> </li>
          <li> <a href="https://www.tiktok.com/@grupoboticario" target="_blank"> <img src="@/assets/images/tiktok.svg" aria-label="tiktok" /> </a> </li>
          <li> <a href="https://www.youtube.com/user/CanalGrupoBoticario" target="_blank"> <img src="@/assets/images/youtube.svg" aria-label="youtube" /> </a> </li>
        </ul>
      </div>

      <div class="col-12 my-5">
        <div class="row">
          <div class="col-12 col-md-10 mx-auto">
            <p class="mb-3">NOSSAS MARCAS:</p>

            <div class="logos">
              <div><img src="@/assets/images/marcas/1.png" /></div>
              <div><img src="@/assets/images/marcas/2.png" /></div>
              <div><img src="@/assets/images/marcas/3.png" /></div>
              <div><img src="@/assets/images/marcas/4.png" /></div>
              <div><img src="@/assets/images/marcas/5.png" /></div>
              <div><img src="@/assets/images/marcas/6.png" /></div>
              <div><img src="@/assets/images/marcas/7.png" /></div>
              <div><img src="@/assets/images/marcas/8.png" /></div>
              <div><img src="@/assets/images/marcas/9.png" /></div>
              <div><img src="@/assets/images/marcas/10.png" /></div>
              <div><img src="@/assets/images/marcas/11.png" /></div>
              <div><img src="@/assets/images/marcas/12.png" /></div>
              <div><img src="@/assets/images/marcas/13.png" /></div>
              <div><img src="@/assets/images/marcas/14.png" /></div>
              <div><img src="@/assets/images/marcas/15.png" /></div>
            </div>
          </div>
        </div>
       </div>

       <div class="col-12 my-5">
        <div class="row">
          <div class="col-12 col-md-10 mx-auto">
            <p class="mb-3">MARCAS LICENCIADAS:</p>

            <div class="logos align-items-start">
              <div><img src="@/assets/images/marcas/licenciadas-1.png" /></div>
              <div><img src="@/assets/images/marcas/licenciadas-2.png" /></div>
              <div><img src="@/assets/images/marcas/licenciadas-3.png" /></div>
              <div><img src="@/assets/images/marcas/licenciadas-4.png" /></div>
            </div>
          </div>
        </div>
       </div>
      
      <div class="col-12">
        <p class="powered-by text-right">POWERED BY <a href="http://99jobs.com/" target="_blank"><strong>99jobs</strong></a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "mainFooter",
};
</script>

<style lang="scss" scoped>
  .main-footer {
    padding: 100px 40px 30px 40px;
    background: #011E38;
  }

  ul {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-right: auto;
    margin: 30px auto 30px auto;
    padding: 0;
    @media (max-width: 980px) {
      margin: 30px 0;
    }

    li {
      list-style: none;
      a {
        margin: 0 20px;
        img {
          height: 24px;
        }
      }
    }
  }

  p {
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: center;
    margin: 0;
    color: #FFFFFF;
    @media (max-width: 980px) {
      line-height: 1.5;
      text-align: center;
    }
  }

  .logos{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    div{
      width: 20%;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: 980px) {
        width: 50%;      
      }
    }
  }

  p.powered-by {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.015em;
    text-align: left;
    margin: 0;

    a {
      color: inherit;
    }
  }
</style>